import classNames from "classnames";
import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconStar from "../../../../img/icons/star.svg";
import { FormRadioSelect } from "../../../forms/FormRadioSelect";
import { IFormUUID } from "../../../models/nominals";
import { IWriteReviewTemplateField } from "../../../models/reviews";
import { useAppDispatch, useAppSelector } from "../../reducers";
import { WriteReviewFormDescriptionCopy } from "../elements/WriteReviewFormDescriptionCopy";
import { reviewFormTextChange } from "../reducers";
import { getWriteReviewFormState } from "../selectors";

interface IProps {
    formUUID: IFormUUID;
    title: string;
    brand?: string;
    name: string;
    field: IWriteReviewTemplateField;
}

export const WriteReviewFormStarsField = (props: IProps): React.ReactNode => {
    const dispatch = useAppDispatch();

    const formState = useAppSelector((state) =>
        getWriteReviewFormState(state.reviews, props),
    );

    const value = formState?.valuesText[props.name] ?? "";
    const errors = formState.errors[props.name] ?? [];
    const showErrors = formState.showErrors;

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        dispatch(
            reviewFormTextChange({
                formUUID: props.formUUID,
                fieldName: props.name,
                fieldValue: e.currentTarget.value,
            }),
        );
    };

    const labels: [number][] = [[1], [2], [3], [4], [5]];
    const choices = labels.map(([rating]) => {
        return {
            value: `${rating}`,
            label: (
                <SVG
                    className="wrf-rating__star"
                    src={iconStar}
                    id={`star-rating-icon-${rating}`}
                    role="img"
                    aria-label={`Rating of ${rating} star${
                        rating > 1 ? "s" : ""
                    }`}
                />
            ),
        };
    });
    const containerClasses = classNames({
        "wrf-rating": true,
        [`wrf-rating--${value}`]: true,
    });
    const label = t`What star rating would you give this product?`;
    return (
        <div className={containerClasses}>
            <h3 className="wrf-rating__title">{props.title}</h3>
            <WriteReviewFormDescriptionCopy brand={props.brand} />
            <FormRadioSelect
                name={props.name}
                id={`${props.name}-${props.formUUID}`}
                required={props.field.is_required}
                label={label}
                legend={label}
                labelPlacement={"static"}
                choices={choices}
                onChange={onChange}
                value={value}
                errors={errors}
                showErrorMessages={showErrors}
            />
        </div>
    );
};
